import { Injectable } from '@angular/core';
import { AbstractRestService } from '@gea-mes/cognito';
import {BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ScportalService extends AbstractRestService {
  
  postInit(): void {
  }
  public isLoading = new BehaviorSubject<boolean>(false);
}
